import { useTranslation } from 'react-i18next';
import useFundContext from '@/contexts/Fund/useFundContext';
import PendingDonationsList from './PendingDonationsList';

const DonationPendingPage = () => {
  const { t } = useTranslation();
  const { currentFund } = useFundContext();

  if (!currentFund) return <h1>{t('noFundSelected')}.</h1>;

  return <PendingDonationsList fundId={currentFund.id} />;
};

export default DonationPendingPage;
